// 养生方案推荐内容配置
// 描述每一类「推荐内容分组」（理疗/饮食/膏方/健食/商品）的元数据：
// - frontKey:    addUserForm 中存储该组的字段名
// - backendKey:  POST 提交时 / detail 回显时使用的后端字段名（BaseHealthPlanDTO 中的 List<BaseHealthPlanList<X>>）
// - itemNameField: 列表分组对象内的输入框字段（'acupointName' / 'dietDishName' / 'productName'）
// - selectorKind:  'acupoint' | 'diet' | 'medicinalFood' | 'healthFood' | 'mallProduct'
// - sourceDataKey: data() 中候选项数组的字段名（autocomplete 数据源）
// - apiPath:       懒加载候选数据的接口（暂未用，预留）
// - apiQuery:      接口入参（懒加载用）
// - textFields:    分组内附带的纯文本字段（艾灸/拔罐/刮痧才有），element { frontKey, backendKey, label, required }
// - innerLabel:    autocomplete 行的 el-form-item label
// - listExtraClass: tag list 容器额外 class（'dietList' 双列展示）
// - sectionLabel:  整组标题

const acupointApi = '/business/base/acupoint/paging';
const dietApi = '/business/base/diet/paging';

export const RECOMMEND_TYPES = [
  {
    frontKey: 'phyMassage',
    backendKey: 'amAcupointLists',
    sectionLabel: '理疗保健 - 按摩',
    innerLabel: '穴位',
    selectorKind: 'acupoint',
    sourceDataKey: 'acupointListData',
    apiPath: acupointApi,
    apiQuery: { type: '按摩' },
    itemNameField: 'acupointName',
  },
  {
    frontKey: 'phyMox',
    backendKey: 'ajAcupointLists',
    sectionLabel: '理疗保健 - 艾灸',
    innerLabel: '穴位',
    selectorKind: 'acupoint',
    sourceDataKey: 'acupointListData',
    apiPath: acupointApi,
    apiQuery: { type: '艾灸' },
    itemNameField: 'acupointName',
    textFields: [
      { frontKey: 'moxOperation', backendKey: 'ajOperation', label: '操作方法', required: true },
      { frontKey: 'moxEffect', backendKey: 'ajEfficacy', label: '功效', required: true },
      { frontKey: 'moxNote', backendKey: 'ajPrecaution', label: '注意事项', required: true },
      { frontKey: 'moxContraindication', backendKey: 'ajContraindication', label: '禁忌症', required: true },
    ],
  },
  {
    frontKey: 'phyCup',
    backendKey: 'bgAcupointLists',
    sectionLabel: '理疗保健 - 拔罐',
    innerLabel: '穴位',
    selectorKind: 'acupoint',
    sourceDataKey: 'acupointListData',
    apiPath: acupointApi,
    apiQuery: { type: '拔罐' },
    itemNameField: 'acupointName',
    textFields: [
      { frontKey: 'cupOperation', backendKey: 'bgOperation', label: '操作方法', required: true },
      { frontKey: 'cupEffect', backendKey: 'bgEfficacy', label: '功效', required: true },
      { frontKey: 'cupNote', backendKey: 'bgPrecaution', label: '注意事项', required: true },
      { frontKey: 'cupContraindication', backendKey: 'bgContraindication', label: '禁忌症', required: true },
    ],
  },
  {
    frontKey: 'phyNeck',
    backendKey: 'gsAcupointLists',
    sectionLabel: '理疗保健 - 刮痧',
    innerLabel: '穴位',
    selectorKind: 'acupoint',
    sourceDataKey: 'acupointListData',
    apiPath: acupointApi,
    apiQuery: { type: '刮痧' },
    itemNameField: 'acupointName',
    textFields: [
      { frontKey: 'neckSummary', backendKey: 'gsSummary', label: '总述', required: true },
      { frontKey: 'neckOperation', backendKey: 'gsOperation', label: '操作方法', required: true },
      { frontKey: 'neckEffect', backendKey: 'gsEfficacy', label: '功效', required: true },
      { frontKey: 'neckNote', backendKey: 'gsPrecaution', label: '注意事项', required: true },
      { frontKey: 'neckContraindication', backendKey: 'gsContraindication', label: '禁忌症', required: true },
    ],
  },
  {
    frontKey: 'dietDish',
    backendKey: 'cuisineLists',
    sectionLabel: '饮食建议-菜肴',
    innerLabel: '菜肴',
    selectorKind: 'diet',
    sourceDataKey: 'dietDishListData',
    apiPath: dietApi,
    apiQuery: { type: '菜肴' },
    itemNameField: 'dietDishName',
    listExtraClass: 'dietList',
  },
  {
    frontKey: 'porridgeList',
    backendKey: 'porridgeLists',
    sectionLabel: '饮食建议-粥食',
    innerLabel: '粥食',
    selectorKind: 'diet',
    sourceDataKey: 'porridgeListData',
    apiPath: dietApi,
    apiQuery: { type: '粥食' },
    itemNameField: 'dietDishName',
    listExtraClass: 'dietList',
  },
  {
    frontKey: 'soup',
    backendKey: 'soupLists',
    sectionLabel: '饮食建议-汤羹',
    innerLabel: '汤羹',
    selectorKind: 'diet',
    sourceDataKey: 'dietSugSoupData',
    apiPath: dietApi,
    apiQuery: { type: '汤羹' },
    itemNameField: 'dietDishName',
    listExtraClass: 'dietList',
  },
  {
    frontKey: 'teaDrink',
    backendKey: 'teaLists',
    sectionLabel: '饮食建议-茶饮',
    innerLabel: '茶饮',
    selectorKind: 'diet',
    sourceDataKey: 'dietSugTeaData',
    apiPath: dietApi,
    apiQuery: { type: '茶饮' },
    itemNameField: 'dietDishName',
    listExtraClass: 'dietList',
  },
  {
    frontKey: 'medicinalFood',
    backendKey: 'medicinalFoodLists',
    sectionLabel: '膏方推荐',
    innerLabel: '膏方',
    selectorKind: 'medicinalFood',
    sourceDataKey: 'medicinalFoodListData',
    apiPath: '/business/base/medicinalFood/paging',
    apiQuery: {},
    itemNameField: 'dietDishName',
    listExtraClass: 'dietList',
  },
  {
    frontKey: 'healthFood',
    backendKey: 'healthFoodLists',
    sectionLabel: '健康食品',
    innerLabel: '健食',
    selectorKind: 'healthFood',
    sourceDataKey: 'healthFoodListData',
    apiPath: '/business/base/healthFood/paging',
    apiQuery: {},
    itemNameField: 'dietDishName',
    listExtraClass: 'dietList',
  },
  // HP3：商城商品（弹窗选品，不走 autocomplete）
  {
    frontKey: 'productList',
    backendKey: 'productLists',
    sectionLabel: '商城商品',
    innerLabel: '推荐商品',
    selectorKind: 'mallProduct',
    sourceDataKey: 'mallProductListData',
    apiPath: '/mall/admin/product/list',
    apiQuery: { status: 1 },
    itemNameField: 'productName',
    listExtraClass: 'dietList',
  },
  // S3：运动健康-保健操
  {
    frontKey: 'bjcExerciseList',
    backendKey: 'bjcExerciseLists',
    sectionLabel: '运动健康-保健操',
    innerLabel: '保健操',
    selectorKind: 'exercise',
    sourceDataKey: 'bjcExerciseListData',
    apiPath: '/business/base/exercises/paging',
    apiQuery: { type: '保健操' },
    itemNameField: 'exerciseName',
    listExtraClass: 'dietList',
  },
  // S3：运动健康-传统功法
  {
    frontKey: 'ctgfExerciseList',
    backendKey: 'ctgfExerciseLists',
    sectionLabel: '运动健康-传统功法',
    innerLabel: '传统功法',
    selectorKind: 'exercise',
    sourceDataKey: 'ctgfExerciseListData',
    apiPath: '/business/base/traditional/exercises/paging',
    apiQuery: { type: '传统功法' },
    itemNameField: 'exerciseName',
    listExtraClass: 'dietList',
  },
  // S3：运动健康-运动
  {
    frontKey: 'sportExerciseList',
    backendKey: 'sportExerciseLists',
    sectionLabel: '运动健康-运动',
    innerLabel: '运动',
    selectorKind: 'exercise',
    sourceDataKey: 'sportExerciseListData',
    apiPath: '/business/base/sport/paging',
    apiQuery: { type: '运动' },
    itemNameField: 'exerciseName',
    listExtraClass: 'dietList',
  },
];

// 为新建/重置表单生成空 list（每个 group 一个空对象，保留旧行为：表单初始展示 1 行可输入）
export function buildEmptyGroupList(cfg) {
  return [{ [cfg.itemNameField]: '', list: [] }];
}

// 生成空表单的所有 list 字段
export function buildEmptyForm() {
  const result = {
    healthPlan: '',
    constitution: '',
    id: '',
  };
  for (const cfg of RECOMMEND_TYPES) {
    result[cfg.frontKey] = buildEmptyGroupList(cfg);
    if (cfg.textFields) {
      for (const tf of cfg.textFields) result[tf.frontKey] = '';
    }
  }
  return result;
}

// 生成 el-form 校验规则（仅文本字段）
export function buildFormRules() {
  const rules = {
    healthPlan: [{ required: true, message: '请输入养生方案名称', trigger: 'change' }],
    constitution: [{ required: true, message: '请选择养生方案', trigger: 'change' }],
  };
  for (const cfg of RECOMMEND_TYPES) {
    if (!cfg.textFields) continue;
    for (const tf of cfg.textFields) {
      if (!tf.required) continue;
      rules[tf.frontKey] = [{
        required: true,
        message: `请输入${cfg.sectionLabel}的${tf.label}`,
        trigger: 'blur',
      }];
    }
  }
  return rules;
}

// 提交时：把 addUserForm 拼成后端 payload
export function toSubmitPayload(addUserForm, includeId) {
  const payload = {
    id: includeId ? addUserForm.id : '',
    name: addUserForm.healthPlan,
    physiqueId: addUserForm.constitution,
  };
  for (const cfg of RECOMMEND_TYPES) {
    payload[cfg.backendKey] = addUserForm[cfg.frontKey];
    if (cfg.textFields) {
      for (const tf of cfg.textFields) payload[tf.backendKey] = addUserForm[tf.frontKey];
    }
  }
  return payload;
}

// 回显时：把 detail 接口数据填回 addUserForm
export function fromDetailResponse(itemData) {
  const form = buildEmptyForm();
  form.healthPlan = itemData.name;
  form.constitution = itemData.physiqueId;
  form.id = itemData.id;
  for (const cfg of RECOMMEND_TYPES) {
    const arr = itemData[cfg.backendKey];
    if (Array.isArray(arr) && arr.length > 0) {
      form[cfg.frontKey] = arr;
    }
    if (cfg.textFields) {
      for (const tf of cfg.textFields) form[tf.frontKey] = itemData[tf.backendKey];
    }
  }
  return form;
}
